import { Guid } from "client_legacy/ndaw/guid";

export type ClientValidationErrorModel = {
	propertyName: string;
	errorMessage: string;
};

export type DatabaseOrTempDtoId = {
	hasDatabaseId: true;
	databaseId: number;
} | {
	hasDatabaseId: false;
	tempId: Guid;
};

export interface TempIdToDatabaseIdMappingModel {
	tempId: Guid;
	databaseId: number;
}

export enum FontFamily {
	Arial = 1,
	CourierNew = 2,
	Georgia = 3,
	Impact = 4,
	LucidaConsole = 5,
	Tahoma = 6,
	TimesNewRoman = 7,
	TrebuchetMs = 8,
	Verdana = 9
}

export enum FontSize {
	ExtraExtraSmall = 1,
	ExtraSmall = 2,
	Small = 3,
	Medium = 4,
	Large = 5,
	ExtraLarge = 6,
	ExtraExtraLarge = 7,
	ExtraExtraExtraLarge = 8
}

export type FontStyleModel = {
	family: FontFamily | null;
	size: FontSize | null;
	bold: boolean;
	italic: boolean;
	underline: boolean;
	color: string | null;
};

export const enum SortDirection {
	Ascending = 0,
	Descending = 1
}

export type IpAddressRange = {
	value: string;
};

export enum Browser {
	Chrome = 1,
	InternetExplorer = 2,
	Firefox = 3,
	Safari = 4,
	Edge = 5,
	Opera = 6
}

export enum OperatingSystem {
	Windows = 1,
	MacOs = 2,
	AndroidChromeOs = 3,
	IOs = 4,
	UnixLinux = 5
}

export enum Device {
	Desktop = 1,
	Tablet = 2,
	Mobile = 3
}

export type KeyValuePair<TKey, TValue> = {
	key: TKey;
	value: TValue;
};

export type UploadedFileInfoViewModel = {
	blobId: string;
	filename: string;
};

export interface PermissionSetModel {
	userIds: readonly number[];
	userGroupIds: readonly number[];
}

export type PermissionsUnionModel = {
	everyone: boolean;
	specificSet: PermissionSetModel | null;
};

export enum ImageAttributionKind {
	Pixabay = 1
}

export type PixabayImageAttributionViewModel = {
	kind: ImageAttributionKind.Pixabay;
	authorId: number;
	authorName: string;
};

export type ImageAttributionViewModel =
	| PixabayImageAttributionViewModel;

export type PixabayImageAttributionSaveModel = {
	authorId: number;
	authorName: string;
};

export type ImageAttributionSaveModel =
	| {
		kind: ImageAttributionKind.Pixabay;
		pixabay: PixabayImageAttributionSaveModel;
	};

export type Base64FileUriUploadModelWithAttribution = Base64FileUriUploadModel & {
	attribution: ImageAttributionSaveModel | null;
};
